import { useQuery, UseQueryOptions } from '@tanstack/react-query'

import { TCampaignScheduleStep } from '~/features/campaigns/models'
import { queryKeys } from '~/features/campaigns/utils'
import { EHttpService, EServerPath } from '~/models/api'
import HttpService from '~/services/http'
import { HttpServiceBaseResponse } from '~/services/http/models'
import pathBuilder from '~/utils/api'

const getCampaignScheduleSteps = (id: string) => {
  return HttpService.get<TCampaignScheduleStep[]>(
    {
      path: pathBuilder(EServerPath.campaignScheduleSteps, { id }),
    },
    EHttpService.internal,
  )
}

const useGetCampaignScheduleSteps = (
  id: string,
  queryOptions?: Omit<
    UseQueryOptions<HttpServiceBaseResponse<TCampaignScheduleStep[]>>,
    'queryKey' | 'queryFn'
  >,
) => {
  return useQuery({
    queryKey: queryKeys.campaignScheduleSteps(id),
    queryFn: () => getCampaignScheduleSteps(id),
    enabled: !!id,
    refetchOnWindowFocus: false,
    ...queryOptions,
    refetchInterval: queryOptions?.refetchInterval || 0,
  })
}

export default useGetCampaignScheduleSteps
